// The Web Share Target (P3.4): Android Chrome and desktop Chrome list the
// installed app in their share sheet (iOS Safari has no share target). The
// share arrives as a multipart POST to SHARE_ACTION, which the service worker
// (app/sw.ts) answers: it keeps the photo and the words in one Cache Storage
// slot and sends the app to SHARED_DRAFT_URL, where capture reads the slot
// once, starts a draft from it, and empties it. Nothing reaches the server
// until the person taps Generate.
//
// The names live here so the worker and the page agree on them, and the
// one decision, which words become the request, is pure and tested.

export const SHARE_ACTION = '/share';
/** Where the service worker sends the app after keeping a share. */
export const SHARED_DRAFT_URL = '/new?shared=1';
/** The form fields the manifest names (share_target.params). */
export const SHARE_FIELDS = { title: 'title', text: 'text', url: 'url', photo: 'photo' } as const;

/** The Cache Storage slot: one share at a time, overwritten by the next. */
export const SHARE_CACHE = 'hd-share';
export const SHARE_SLOT = { meta: '/__share/meta', photo: '/__share/photo' } as const;

/** What the slot's meta entry holds, as JSON. */
export interface SharedMeta { title: string; text: string; url: string; at: number; photo: boolean }

/** A shared draft older than this is left alone: the app opened to it long after, from history. */
export const SHARE_FRESH_MS = 10 * 60 * 1000;

/** The longest request the list keeps (worker/list/validate.ts). */
const REQUEST_MAX = 4000;
const isLink = (s: string) => /^https?:\/\/\S+$/i.test(s);

/**
 * The request a share becomes. A web page (a link, or text that is only a
 * link) gives its title, else any words with it, else the link, as iOS's
 * share extension does with a page; anything else gives its words, else its
 * title.
 */
export function sharedRequest({ title, text, url }: Pick<SharedMeta, 'title' | 'text' | 'url'>): string {
  const t = title.trim(), words = text.trim();
  const link = url.trim() || (isLink(words) ? words : '');
  const note = isLink(words) ? '' : words;
  const request = link ? t || note || link : note || t;
  return request.slice(0, REQUEST_MAX);
}
